export default __webpack_public_path__ + "static/bsc-certik-logo-40b241bee61a6864de498e6e2aa568a7.png";